import React from 'react';
import { motion } from 'framer-motion';
import { LOGO_URL } from '../constants/site';
const SELECT_SHOT_URL = 'https://cdn.magicpatterns.com/uploads/6sYWZGswrybZ2wW9nGSRUv/cropped_screenshot.png';
const RESULT_SHOT_URL = 'https://cdn.magicpatterns.com/uploads/71tLF6WJ1FdW35yr6sgJS7/image.png';
const STEPS = [{
  n: '1',
  title: 'Open a post',
  body: 'Head to any post on x.com or twitter.com.'
}, {
  n: '2',
  title: 'Click the icon',
  body: 'Click the X2PIC icon in your Chrome toolbar to start pick mode.',
  showIcon: true
}];
const SHOWCASE_STEPS = [{
  n: '3',
  title: 'Select & capture',
  body: 'Click the post and any replies you want, then hit Capture (Esc to cancel).',
  src: SELECT_SHOT_URL,
  alt: 'X2PIC pick mode with the selected post highlighted, ready to capture'
}, {
  n: '4',
  title: 'Download or copy',
  body: 'In the result dialog, save the PNG to disk or copy it to your clipboard.',
  src: RESULT_SHOT_URL,
  alt: 'X2PIC result dialog showing the captured post with style options and Download and Copy buttons'
}];
export function HowItWorks() {
  return <section id="how" className="w-full scroll-mt-16 bg-slate-50 py-20 sm:py-24" data-id="element-130" data-mp="2mki4rdyroxnt">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-131" data-mp="31d22u0728eye">
        <div className="mx-auto max-w-2xl text-center" data-id="element-132" data-mp="2wk8xpb7oj4ls">
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-133" data-mp="2wio3jmpa1nog">
            Four clicks to a perfect screenshot
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-134" data-mp="36bc2oo3qc3qc">
            No setup, no account — just install and go.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-135" data-mp="3k9k170gezd3m">
          {STEPS.map((s, i) => <motion.div key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="relative rounded-2xl border border-slate-200 bg-white p-6" data-id="element-136" data-mp="3fc1rh7ukotuk" data-mpi={i}>
              {s.showIcon && <div className="absolute right-4 top-4" data-id="element-137" data-mp="2uncv1eyiuva">
                  <motion.span animate={{
              scale: [1, 0.9, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-138" data-mp="7t6z72xgq8o6">
                    <img src={LOGO_URL} alt="X2PIC toolbar icon" className="h-7 w-7 object-contain" data-id="element-139" data-mp="qhc104uk7jkc" />
                  </motion.span>
                  <motion.span aria-hidden="true" className="pointer-events-none absolute -bottom-2 -right-2" animate={{
              x: [4, -2, 4],
              y: [4, -2, 4]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-140" data-mp="10ndamlmj4fky">
                    <FingerCursor data-id="element-141" data-mp="1jemsbi6geanm" />
                  </motion.span>
                </div>}
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1d9bf0] text-base font-bold text-white" data-id="element-142" data-mp="1el1upr8rvioy">
                {s.n}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-slate-900" data-id="element-143" data-mp="2750e4qyg3d9r">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-144" data-mp="22bfllefmfbhy">
                {s.body}
              </p>
            </motion.div>)}
        </div>

        {SHOWCASE_STEPS.map(s => <motion.div key={s.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4
      }} className="mt-6 grid items-center gap-6 overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 sm:grid-cols-2 sm:p-8" data-id="element-145" data-mp="1rrpnk2v5e47z">
            <div data-id="element-146" data-mp="20tyvckz17jho">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1d9bf0] text-base font-bold text-white" data-id="element-147" data-mp="20tfdt5damx46">
                {s.n}
              </span>
              <h3 className="mt-4 text-xl font-semibold text-slate-900" data-id="element-148" data-mp="2tbb9jrpadanf">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-149" data-mp="hv12wbge75x3">
                {s.body}
              </p>
            </div>
            <div className="flex justify-center sm:justify-end" data-id="element-150" data-mp="cwfzk35ug64f">
              <span className="block w-full max-w-[460px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-md" data-id="element-151" data-mp="rkkin88t6jnq">
                <img src={s.src} alt={s.alt} className="h-full w-full object-contain" data-id="element-152" data-mp="mnawc1gpuo44" />
              </span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}
function FingerCursor() {
  return <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-153" data-mp="8wp8rzgbhpzw">
      <path d="M9.5 3.2c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v8.1l1.1-2.1c.5-1 1.7-1.4 2.7-.9 1 .5 1.4 1.7.9 2.7l-.4.7 1.6-.4c1.1-.3 2.2.4 2.5 1.5l.1.4 1.4-.1c1.1 0 2 .8 2.1 1.9l.4 5.2c.2 3.2-2.2 6-5.4 6.4l-4.6.5c-2.1.2-4.1-.7-5.4-2.4L5 18.6c-.7-1-.5-2.4.5-3.1 1-.7 2.4-.5 3.1.5l.9 1.2V3.2z" fill="#fff" stroke="#0f172a" strokeWidth="1.4" strokeLinejoin="round" data-id="element-154" data-mp="1ka9ktox98pqx" />
    </svg>;
}